import React from "react";
import "./NoLivesPopup.css";

const NoLivesPopup = ({ onClose }) => {
  return (
    <div className="nolives-overlay">
      <div className="nolives-popup">

        <h2>Ai rămas fără vieți 💔</h2>
        <p>
          Din păcate ai epuizat toate cele 3 vieți ale acestei lecții.
        </p>
        <p>
          Poți reîncerca lecția oricând ești pregătit! 🚀
        </p>

        <button className="nolives-btn" onClick={onClose}>
          Înapoi la lecții
        </button>
      </div>
    </div>
  );
};

export default NoLivesPopup;
